import { put, select, takeLatest } from 'redux-saga/effects'
import { getProcedureStateSelector } from '../../../../components/procedure/selectors'
import { setInputRows } from '../../../../components/procedure/store/procedure.actions'
import { IProcedureState } from '../../../../components/procedure/store/procedure.types'
import { getOperationsSelector } from '../selectors'
import { OperationsConstants } from '../store/operations.constants'
import { IOperationsState } from '../store/operations.types'

export function* setJointCommissionTimeOut() {
  const procedureState: IProcedureState = yield select(getProcedureStateSelector)
  const operationsState: IOperationsState = yield select(getOperationsSelector)
  const { inputRows } = procedureState
  const { jointCommissionTimeOut } = operationsState
  inputRows.map((row) =>
    row.inputs.map((input) => {
      if (input.key === OperationsConstants.SET_RIGHT_PATIENT) {
        input.hidden = jointCommissionTimeOut ? false : true
      }
      if (input.key === OperationsConstants.SET_RIGHT_PROCEDURE) {
        input.hidden = jointCommissionTimeOut ? false : true
      }
      if (input.key === OperationsConstants.SET_RIGHT_CONSENT) {
        input.hidden = jointCommissionTimeOut ? false : true
      }
      if (input.key === OperationsConstants.SET_RIGHT_SITE_SIDE) {
        input.hidden = jointCommissionTimeOut ? false : true
      }
      if (input.key === OperationsConstants.SET_RIGHT_POSITION) {
        input.hidden = jointCommissionTimeOut ? false : true
      }
      if (input.key === OperationsConstants.SET_COMPLETE) {
        input.hidden = jointCommissionTimeOut ? false : true
      }
    })
  )
  yield put(setInputRows(inputRows))
}

export function* setJointCommissionTimeOutSaga() {
  yield takeLatest(
    [OperationsConstants.SET_JOINT_COMMISSION_TIME_OUT, OperationsConstants.SET_UPDATE_INPUT_ROWS],
    setJointCommissionTimeOut
  )
}
